module.exports = __webpack_public_path__ + "img/03-vise-pro.297641cc.jpeg";